// CTV-787: the Payout method settings tab at /admin/:slug/settings/payout-method.
// Where a manager connects, resumes, or checks the station's Stripe payout
// destination. The section itself is unchanged since CTV-776; only its
// address moved, off the Billing tab and into Station settings.
//
// The manager+ gate lives once in PublisherSettingsLayout. The flag check
// stays here as well as on the tab strip so a typed URL cannot reach a
// surface production hides.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSingleStationContext } from '../../components/self-service/admin/useAdminContext';
import { publisherBillingEnabled } from '../../components/self-service/admin/payoutsFeature';
import PayoutMethodSection from '../../components/self-service/billing/PayoutMethodSection';

const PublisherPayoutMethodPage: React.FC = () => {
  const { slug } = useSingleStationContext();

  if (!publisherBillingEnabled()) {
    return <Navigate to={`/admin/${slug}/settings/team`} replace />;
  }

  return (
    <div className="max-w-5xl">
      <PayoutMethodSection slug={slug} />
    </div>
  );
};

export default PublisherPayoutMethodPage;
